namespace Matrix.Data {
    export class StoredProcParametersColumns {
        static columnsKey = 'Data.StoredProcParameters';
    }
}
